import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createSlots as _createSlots, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-accd1978"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-sousuo1"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jiahao"
}, null, -1));
import Dialog from "./components/dialog.vue";
import tagDialog from "./components/tagDialog.vue";
import { computed, onMounted, reactive, ref } from "vue";
import api from "@/api/system/users";
import { useDel } from "@/hook/useDel";
import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
export default {
  __name: 'index',
  setup(__props) {
    const {
      t
    } = useI18n();
    const params = reactive({
      name: "",
      page: 1,
      limit: 10
    });
    const list = ref([]);
    const loading = ref(false);
    const total = ref(0);
    const loadList = async query => {
      if (query === "query") {
        params.page = 1;
      }
      loading.value = true;
      try {
        const {
          data
        } = await api.userList(params);
        if (data.code !== 0) return;
        list.value = data.data.list;
        total.value = data.data.total;
      } finally {
        loading.value = false;
      }
    };
    // 不予操作
    const noAction = computed(() => roleId => {
      if (!roleId) {
        return true;
      }
      return false;
    });
    const dialogRef = ref(null);
    const handleClick = (state, row) => {
      const status = state === "add" ? true : false;
      status ? dialogRef.value.open() : dialogRef.value.open(row);
    };
    const tagDialogRef = ref(null);
    const handleDel = row => {
      useDel(async () => {
        const {
          data
        } = await api.deleteUser({
          id: row.id
        });
        if (data.code !== 0) return;
        ElMessage.success(t("action.success"));
        loadList("query");
      });
    };
    // 重置密码
    const handleReset = async row => {
      try {
        await ElMessageBox.confirm(t("users.message.resetPasswordConfirmation", {
          val: row.name
        }), t("action.tips"), {
          confirmButtonText: t("action.confirmBtn"),
          cancelButtonText: t("action.cancel"),
          type: "warning"
        });
        const {
          data
        } = await api.resetPassword({
          id: row.id
        });
        if (data.code !== 0) return;
        ElMessage.success(t("action.success"));
      } catch (err) {
        console.log(err);
      }
    };
    const labelList = ref([]);
    // 获取标签列表
    const getLabelList = async () => {
      // const { data } = await labelApi.listTag();
      // if (data.code !== 0) return {};
      // labelList.value = data.data.list;
    };
    onMounted(() => {
      loadList("query");
      getLabelList();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_NoData = _resolveComponent("NoData");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Pagination = _resolveComponent("Pagination");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_card, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          size: "large",
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('users.table.name')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: _ctx.$t('common.pleaseEnter', {
                val: _ctx.$t('users.table.name')
              }),
              modelValue: params.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.name = $event),
              clearable: ""
            }, null, 8, ["placeholder", "modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "success",
              onClick: _cache[1] || (_cache[1] = $event => loadList('query'))
            }, {
              default: _withCtx(() => [_hoisted_2, _createTextVNode(" " + _toDisplayString(_ctx.$t("common.search")), 1)]),
              _: 1
            }), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = $event => handleClick('add'))
            }, {
              default: _withCtx(() => [_hoisted_3, _createTextVNode(" " + _toDisplayString(_ctx.$t("common.add")), 1)]),
              _: 1
            })), [[_directive_permission, '/user/add']])]),
            _: 1
          })]),
          _: 1
        })]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          style: {
            "margin-bottom": "20px"
          }
        }, _createSlots({
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "id",
            label: _ctx.$t('task.list.uid'),
            width: "80"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "username",
            label: _ctx.$t('users.table.username')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "name",
            label: _ctx.$t('users.table.name')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('users.table.avatar'),
            width: "150"
          }, {
            default: _withCtx(({
              row
            }) => [row.avatar ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              "preview-teleported": true,
              style: {
                "width": "100px",
                "height": "100px"
              },
              src: row.avatar,
              "preview-src-list": [row.avatar]
            }, null, 8, ["src", "preview-src-list"])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "roleName",
            label: _ctx.$t('users.form.roleId')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "introduction",
            label: _ctx.$t('users.table.introduction')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "createdAt",
            label: _ctx.$t('users.table.createdAt'),
            width: "200"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('common.action'),
            width: "300"
          }, {
            default: _withCtx(({
              row
            }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleClick('edit', row),
              disabled: noAction.value(row.roleId)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.edit")), 1)]),
              _: 2
            }, 1032, ["onClick", "disabled"])), [[_directive_permission, '/user/edit']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "danger",
              disabled: noAction.value(row.roleId),
              onClick: $event => handleDel(row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.del")), 1)]),
              _: 2
            }, 1032, ["disabled", "onClick"])), [[_directive_permission, '/user/del']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "info",
              disabled: noAction.value(row.roleId),
              onClick: $event => handleReset(row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.resetPasswords")), 1)]),
              _: 2
            }, 1032, ["disabled", "onClick"])), [[_directive_permission, '/user/reset_password']])]),
            _: 1
          }, 8, ["label"])]),
          _: 2
        }, [!loading.value ? {
          name: "empty",
          fn: _withCtx(() => [_createVNode(_component_NoData)]),
          key: "0"
        } : undefined]), 1032, ["data"])), [[_directive_loading, loading.value]]), _withDirectives(_createVNode(_component_Pagination, {
          total: total.value,
          page: params.page,
          "onUpdate:page": _cache[3] || (_cache[3] = $event => params.page = $event),
          limit: params.limit,
          "onUpdate:limit": _cache[4] || (_cache[4] = $event => params.limit = $event),
          onPagination: loadList
        }, null, 8, ["total", "page", "limit"]), [[_vShow, total.value > 0]]), _createVNode(Dialog, {
          ref_key: "dialogRef",
          ref: dialogRef,
          onLoadList: _cache[5] || (_cache[5] = $event => loadList('query')),
          labelList: labelList.value
        }, null, 8, ["labelList"]), _createVNode(tagDialog, {
          ref_key: "tagDialogRef",
          ref: tagDialogRef,
          labelList: labelList.value,
          onLoadList: _cache[6] || (_cache[6] = $event => loadList('query'))
        }, null, 8, ["labelList"])]),
        _: 1
      });
    };
  }
};